"use client";
import React, { useEffect, useState } from "react";
import { DeliveryOrderModal } from "./deliveryOrderModal";
import {
  getFromLocalStorage,
  saveToLocalStorage,
} from "@/utils/localStorageUtils";
import { LocalStorageKey } from "@/utils/storageKeys";
import { OrderType } from "@/constants/enum";
import { useNativeActions } from "@/utils/useNativeActions";

export const OnloadPopUp = ({ merchant, merchantColor, orderType }: any) => {
  const { isCmaApp } = useNativeActions();
  const isPopupTouched = getFromLocalStorage<boolean>(
    LocalStorageKey.NEWCOLO_ONLOADPOP_ISTOUCHED,
    false
  );
  const [isTouched, setIsTouched] = useState(!!isPopupTouched);
  const [isPreview, setIsPreview] = useState<boolean>(false);

  useEffect(() => {
    setIsPreview(globalThis.location.hostname.startsWith("preview-"));
  }, []);

  const closeModal = () => {
    const existingFlag = Boolean(isPopupTouched);
    saveToLocalStorage(
      LocalStorageKey.NEWCOLO_ONLOADPOP_ISTOUCHED,
      !existingFlag
    );
    setIsTouched(!existingFlag);
  };

  if (
    isTouched ||
    isPreview ||
    orderType?.toLowerCase() === OrderType.DINE_IN.toLowerCase() ||
    isCmaApp
  )
    return null;

  return (
    <DeliveryOrderModal
      onRequestClose={closeModal}
      merchant={merchant}
      merchantColor={merchantColor}
    />
  );
};
